import React, { useState } from "react";
import styled, { css } from "styled-components";
import ToggleLayersIcon from "../../assets/images/layers-icon.svg";
import { getIconUrl } from "../../plugins/unt/assets/iconUrls";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

const ToggleSelector = styled.button.attrs((props) => ({
  className: "bn bg-white shadow-4 relative",
}))`
  background-image: url(${ToggleLayersIcon});
  background-size: 80%;
  background-repeat: no-repeat;
  background-position: center;
  width: 2rem;
  height: 2rem;
  border-radius: 2rem;
  line-height: 18px;
`;

const SelectorMetaInfo = styled.div.attrs((props) => ({
  className: "ml1 br-pill absolute",
}))`
  left: 100%;
  top: 0px;
  font-weight: normal;
  .selectCount {
  }
  .total {
    font-weight: normal;
    color: rgba(0, 0, 0, 0.4);
  }
  text-align: center;
  font-size: 12px;
  height: 16px;
  line-height: 16px;
  width: 56px;
  background-color: white;
`;

const Checkbox = styled.div.attrs((props) => ({
  className: "dib categoryCheckbox",
}))`
  background-image: url(${(props) => props.icon});
  height: 18px;
  width: 18px;
  margin-right: 0.33rem;
  vertical-align: bottom;
  background-size: 100%;
  background-repeat: no-repeat;
`;

const SelectableResults = styled.ul.attrs((props) => ({
  className: "list pl0 ma0 f6",
}))``;

const SelectableResultItem = styled.li.attrs((props) => ({
  className: "bg-white mt1 pv2 ph3 br-pill shadow-4 pointer",
}))`
  color: rgba(0, 0, 0, 0.44);
  & > .categoryCheckbox {
    opacity: 40%;
  }

  ${(props) =>
    props.checked &&
    css`
      color: rgba(0, 0, 0, 1);
      & > .categoryCheckbox {
        opacity: 100%;
      }
    `};
`;

function MapLayersSelector(props) {
  const [isSelectorExpanded, setIsSelectorExpanded] = useState(
    !!props.isSelectorExpanded ? props.isSelectorExpanded : true
  );
  const [descriptionVisible, setDescriptionVisible] = useState();

  const selectablesAsArray = Object.entries(props.selectables || []);
  let selectedCategoriesCount = selectablesAsArray.length;
  if (selectablesAsArray.length !== 0) {
    selectedCategoriesCount = selectablesAsArray.reduce(
      (total, selectable) => (selectable[1].selected ? ++total : total),
      0
    );
  }

  return (
    <div>
      <ToggleSelector
        onClick={() => setIsSelectorExpanded((prevState) => !prevState)}
      >
        <SelectorMetaInfo>
          {props.selectables === null ? (
            "lädt ..."
          ) : (
            <>
              {selectedCategoriesCount}
              <span className="total"> von {selectablesAsArray.length}</span>
            </>
          )}
        </SelectorMetaInfo>
      </ToggleSelector>

      {isSelectorExpanded && (
        <div>
          <SelectableResults>
            {!!props.selectables &&
              selectablesAsArray.map(([selectableKey, selectableValue]) => {
                return (
                  <SelectableResultItem
                    checked={!!selectableValue.selected ? true : false}
                    key={selectableKey}
                    onClick={() => props.onCategoryFilterClick(selectableKey)}
                  >
                    <Checkbox
                      checked={!!selectableValue.selected ? true : false}
                      icon={getIconUrl(selectableValue.icon.icon_url)}
                    />
                    {selectableValue.displayName}
                    {selectableValue.description && (
                      <div
                        className={`dib relative`}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          if (
                            !!descriptionVisible &&
                            descriptionVisible === selectableValue.displayName
                          ) {
                            setDescriptionVisible(null);
                          } else {
                            setDescriptionVisible(selectableValue.displayName);
                          }
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faInfoCircle}
                          className="ml2 o-50"
                        />
                        {descriptionVisible === selectableValue.displayName && (
                          <div
                            className="absolute pv3 ph3 br2 shadow-4 bg-white br4"
                            style={{
                              left: "2.5rem",
                              top: "-0.5rem",
                              width: "180px",
                            }}
                          >
                            <p className="pa0 ma0">{selectableValue.description}</p>
                          </div>
                        )}
                      </div>
                    )}
                  </SelectableResultItem>
                );
              })}
          </SelectableResults>
        </div>
      )}
    </div>
  );
}

export default MapLayersSelector;
